import React from "react";
import Envelope from "./components/Envelope";
import "./App.css";

const App = () => {
  return (
    <div className="app">
      <Envelope />
    </div>
  );
};

export default App;
